import React from 'react';
import PropTypes from 'prop-types';

import './Icon.scss';

const propTypes = {
    iconName: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

const Icon = ({ iconName, children, ...props }) => React.cloneElement(children, { className: `Icon ${iconName}`, ...props });

Icon.propTypes = propTypes;

export default Icon;
